import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-health-coaching',
  templateUrl: './health-coaching.component.html',
  styleUrls: ['./health-coaching.component.scss']
})
export class HealthCoachingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
